import { Cart, CartLine, IContext, LineDeliverySpecification } from '@msdyn365-commerce/retail-proxy';
import {
    updateAsync,
    updateCartLinesAsync,
    updateLineDeliverySpecificationsAsync
} from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { IActionContext } from '@msdyn365-commerce/core';

export const updateLineDeliverySpecifications = async (
    context: IContext,
    cartId: string,
    lineDeliverySpecifications: LineDeliverySpecification[]
): Promise<Cart> => {
    return updateLineDeliverySpecificationsAsync(context, cartId, lineDeliverySpecifications).catch(err => {
        console.log(err);
        return err;
    });
};

export const getCartLinesforSubscription = (cartLine: CartLine[]): CartLine[] => {
    return cartLine?.filter(line => isSubscriptionLine(line)) || [];
};

export const getCartLinesforDelivery = (cartLine: CartLine[]): CartLine[] => {
    return cartLine?.filter(line => isDeliveryLine(line)) ?? [];
};

export const getCartLinesforPickup = (cartLine: CartLine[]): CartLine[] => {
    return cartLine?.filter(line => isPickupLine(line)) ?? [];
};

export const updateCartLines = (context: IContext, id: string, cartLines: CartLine[] | null | undefined) => {
    return updateCartLinesAsync(context, id, cartLines);
};

export const updateCartLineAttributeValues = async (
    lineId: string,
    attributeKey: string,
    attributeValue: string,
    actionContext: IActionContext,
    cart: Cart
) => {
    const cartLines = cart.CartLines;

    cartLines?.map((cartLine, index) => {
        if (cartLine.LineId === lineId) {
            const newAttribute = {
                '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.AttributeTextValue',
                ExtensionProperties: [],
                Name: attributeKey,
                TextValue: attributeValue,
                TextValueTranslations: []
            };

            if (cartLine.AttributeValues) {
                const attrIndex = cartLine.AttributeValues.findIndex(attr => attr.Name === attributeKey);

                if (attrIndex > -1) {
                    // eslint-disable-next-line security/detect-object-injection
                    cartLine.AttributeValues[attrIndex] = newAttribute;
                } else {
                    cartLine.AttributeValues.push(newAttribute);
                }
            } else {
                cartLine.AttributeValues = [];
                cartLine.AttributeValues.push(newAttribute);
            }
        }
    });

    const newCart = await updateCartLinesAsync({ callerContext: actionContext }, cart.Id, cartLines);
    await updateAsync({ callerContext: actionContext }, newCart);
};

const isSubscriptionLine = (line: CartLine): boolean => {
    const isSubscription = line?.ExtensionProperties?.find(x => x.Key === 'isSubscription')?.Value?.BooleanValue || false;

    //commeted out because all subscriptions need subscription addresses regardless of serv country or not
    // const isManualSubscription = line?.ExtensionProperties?.find(x => x.Key === 'isManualSubscription')?.Value?.BooleanValue || false;

    // return isSubscription && !isManualSubscription;
    return isSubscription;
};

const isDeliveryLine = (line: CartLine): boolean => {
    return !isPickupLine(line) && (line.FulfillmentStoreId === undefined || line.FulfillmentStoreId === '') && !isSubscriptionLine(line);
};

const isPickupLine = (line: CartLine): boolean => {
    return line.DeliveryMode === 'PICKUP' || line.DeliveryMode === 'CURBSIDE';
};
